"use client";

import { useSyncExternalStore } from "react";

// Subscribed rather than checked once: Cookiebot loads from its own CDN and is not reliably
// there by the time this mounts, so a single check on mount leaves the control hidden for good
// on the runs where it lost the race.
const subscribeToCookiebot = (onLoad: () => void) => {
  window.addEventListener("CookiebotOnLoad", onLoad);

  return () => window.removeEventListener("CookiebotOnLoad", onLoad);
};

const isCookiebotLoaded = () => Boolean(window.Cookiebot);

const isCookiebotLoadedOnServer = () => false;

/**
 * Reopens the consent dialog, so answering the banner is not a one-way door.
 *
 * Rendered only once Cookiebot is actually on the page: blocked or still loading, this would
 * look like a control and do nothing.
 *
 * Calls Cookiebot directly rather than going through `useCookiebotRenewal`, which listens for
 * the URL hash to change — a second press would leave the hash where it is and do nothing, and
 * the hook is bound to the Pages Router.
 */
const CookieSettings = ({ label }: { label: string }) => {
  const available = useSyncExternalStore(
    subscribeToCookiebot,
    isCookiebotLoaded,
    isCookiebotLoadedOnServer,
  );

  if (!available) {
    return null;
  }

  return (
    <button
      type="button"
      onClick={() => window.Cookiebot?.show(true)}
      className="p-none bg-transparent border-none cursor-pointer text-inherit text-neutral-425 hover:text-primary-800 transition-colors focusable rounded-xs"
    >
      {label}
    </button>
  );
};

export default CookieSettings;
